import { Injectable, InjectFlags, Optional } from '@angular/core';
import { Observable, from, of, empty, EMPTY } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { UploadDialogService, UploadFileInfo, UploadLimit, DownloadService, FileState } from '@gsp-svc/formdoc-upload';
import { FileViewerService } from '@gsp-svc/file-viewer';
import { FrameContext, BindingData, BindingPathConverter, BindingList, DataPathUtil, DataPathCreator, EntityList, Entity } from '@farris/devkit';
import { FormNotifyService } from '../form-notify.service';
import { AttachmentUtil } from './attachment.util';
import { AttachmentDataService } from './attachment-data.service';
import { LanguageService } from '../languag.service';
import { EntityService } from '../entity-services/index';
import { BefRepository } from '@farris/bef';
import { BasePathService } from '@farris/rtf';

// tslint:disable: max-line-length
/**
 * éä»¶æå¡
 */
@Injectable()
class AttachmentService {
  /**
   * é»è®¤æ ¹ç®å½
   */
  private defaultRootDirId = '';

  /**
   * é»è®¤ç¶è·¯å¾
   */
  private get defaultParentDirName(): string {
    return this.frameContext.bindingData.list.currentId;
  }

  /**
   * ç»å®æ°æ®
   */
  private get bindingData(): BindingData {
    return this.frameContext.bindingData;
  }

  /**
   * å¤è¯­æå¡
   */
  private languageService: LanguageService;

  /**
   * éä»¶é¢è§æå¡
   */
  private fileViewerService: FileViewerService;

  /**
   * å®ä½æå¡
   */
  private entityService: EntityService;

  /**
   * æé å½æ°
   */
  constructor(
    private frameContext: FrameContext,
    private attachDataService: AttachmentDataService,
    private notifyService: FormNotifyService,
    private uploadDialogService: UploadDialogService,
    @Optional() private downloadService: DownloadService
  ) {
    this.setLanguageService();
    this.fileViewerService = this.frameContext.injector.get<FileViewerService>(FileViewerService, null, InjectFlags.Optional);
    this.entityService = this.frameContext.injector.get<EntityService>(EntityService, null, InjectFlags.Optional);
    if (!this.downloadService && typeof DownloadService !== 'undefined') {
      this.downloadService = this.frameContext.injector.get<DownloadService>(DownloadService, null);
    }
  }

  /**
   * è®¾ç½®è¯­è¨æå¡
   */
  private setLanguageService() {
    const injector = this.frameContext.injector;
    this.languageService = injector.get<LanguageService>(LanguageService, null, InjectFlags.Optional);
    if (!this.languageService) {
      this.languageService = LanguageService.getInstance();
    }
  }

  /**
   * ä¸ä¼ åä¸ªæä»¶
   * @param attachmentIdPath éä»¶åç å­æ®µçè·¯å¾ï¼å½¢å¦/attachInfo/attachmentIdï¼
   * @param attachmentNamePath éä»¶åç§°å­æ®µçè·¯å¾
   */
  public uploadAndUpdateRow(attachmentInfoFieldPath: string, rootDirId?: string, parentDirName?: string, fileType?: string, id?: string): Observable<any> {
    const rootId = rootDirId ? rootDirId : this.defaultRootDirId;
    const formId = parentDirName ? parentDirName : this.defaultParentDirName;
    if (!rootId || !formId) {
      throw new Error('rootDirIdåparentDirNameä¸è½ä¸ºç©ºï¼è¯·å¡«å');
    }

    const uploadLimit: UploadLimit = new UploadLimit();
    uploadLimit.fileCount = 1;
    if (fileType) {
      uploadLimit.fileType = fileType;
    }
    // è·åèçéä»¶idæ°ç»
    const attachmentIdList = [];
    let currentItem = null;
    if (id) {
      // ä¿®æ­£å½åè¡
      const bindingList: BindingList = this.frameContext.bindingData.getList();
      if (bindingList.currentId !== id) {
        bindingList.setCurrentId(id, true, true);
      }
      // å¦ææå®äºidåè·åæå®idçè¡
      currentItem = this.getSpecialRow(attachmentInfoFieldPath, id);
    } else {
      // æ²¡ææå®åä½¿ç¨å½åè¡ï¼å¯è½å­å¨å½åè¡åäºä»¶è¡ä¸ä¸è´çæåµï¼æ­¤æ¶åºè¯¥å¨å½ä»¤ä¸­ä¼ éidåæ°
      currentItem = this.getCurrentRow(attachmentInfoFieldPath);
    }
    if (currentItem && currentItem.primaryKeyValue) {
      const attachmentIds = this.getAttachmentIdsByPathAndDataIds(attachmentInfoFieldPath, [currentItem.primaryKeyValue]);
      if (attachmentIds && attachmentIds.length > 0) {
        attachmentIdList.push.apply(attachmentIdList, attachmentIds);
      }
    } else {
      this.notifyService.warning(this.languageService.plsSelectUpdateRow, { hideTitle: true });
      return EMPTY;
    }

    const dialog$ = from(this.uploadDialogService.uploadFileWithLimit(formId, rootId, uploadLimit, attachmentIdList));
    const result$ = dialog$.pipe(
      switchMap((fileInfos: UploadFileInfo[]) => {
        if (!fileInfos || fileInfos.length === 0) {
          this.notifyService.warning(this.languageService.plsUploadFirst, { hideTitle: true });
          return empty();
        }
        // è¿æ»¤åºstateä¸ºæ°å¢çéä»¶
        fileInfos = fileInfos.filter((fileInfo: UploadFileInfo) => {
          if (fileInfo.hasOwnProperty('state')) {
            return fileInfo.state === FileState.New;
          }
          return true;
        });
        if (fileInfos.length === 0) {
          return of(true);
        }
        // æ¯å¦ä¸ä¼ å¤æ­
        const attachmentInfos = AttachmentUtil.convertToAttachmentInfos(fileInfos);
        const firstAttachmentInfo = AttachmentUtil.getFirstAttachmentInfo(attachmentInfos);
        return this.attachDataService.updateRow(attachmentInfoFieldPath, firstAttachmentInfo);
      })
    );

    return result$;
  }
  /**
   * ä¸ä¼ åä¸ªæä»¶ï¼æ¯æå¤åï¼
   * @param attachmentInfoFieldPath éä»¶åç å­æ®µçè·¯å¾ï¼å½¢å¦/attachInfo/attachmentIdï¼
   * @param rootDirId éä»¶å­å¨æ ¹ç®å½
   * @param parentDirName éä»¶å­å¨ç®å½
   * @param fileType æä»¶ç±»åï¼like .txt,.docx
   */
  public uploadAndUpdateRowWithPropertyName(attachmentInfoFieldPath: string, rootDirId?: string, parentDirName?: string, fileType?: string, id?: string): Observable<any> {
    const rootId = rootDirId ? rootDirId : this.defaultRootDirId;
    const formId = parentDirName ? parentDirName : this.defaultParentDirName;
    if (!rootId || !formId) {
      throw new Error('rootDirIdåparentDirNameä¸è½ä¸ºç©ºï¼è¯·å¡«å');
    }

    const uploadLimit: UploadLimit = new UploadLimit();
    uploadLimit.fileCount = 1;
    if (fileType) {
      uploadLimit.fileType = fileType;
    }

    // è·åèçéä»¶idæ°ç»
    const attachmentIdList = [];
    let currentItem = null;
    if (id) {
      // ä¿®æ­£å½åè¡
      const bindingList: BindingList = this.frameContext.bindingData.getList();
      if (bindingList.currentId !== id) {
        bindingList.setCurrentId(id, true, true);
      }
      // å¦ææå®äºidåè·åæå®idçè¡
      currentItem = this.getSpecialRow(attachmentInfoFieldPath, id);
    } else {
      // æ²¡ææå®åä½¿ç¨å½åè¡ï¼å¯è½å­å¨å½åè¡åäºä»¶è¡ä¸ä¸è´çæåµï¼æ­¤æ¶åºè¯¥å¨å½ä»¤ä¸­ä¼ éidåæ°
      currentItem = this.getCurrentRow(attachmentInfoFieldPath);
    }
    if (currentItem && currentItem.primaryKeyValue) {
      const attachmentIds = this.getAttachmentIdsByPathAndDataIds(attachmentInfoFieldPath, [currentItem.primaryKeyValue]);
      if (attachmentIds && attachmentIds.length > 0) {
        attachmentIdList.push.apply(attachmentIdList, attachmentIds);
      }
    } else {
      this.notifyService.warning(this.languageService.plsSelectUpdateRow, { hideTitle: true });
      return EMPTY;
    }

    const dialog$ = from(this.uploadDialogService.uploadFileWithLimit(formId, rootId, uploadLimit, attachmentIdList));
    const result$ = dialog$.pipe(
      switchMap((fileInfos: UploadFileInfo[]) => {
        if (!fileInfos || fileInfos.length === 0) {
          this.notifyService.warning(this.languageService.plsUploadFirst, { hideTitle: true });
          return EMPTY;
        }
        // è¿æ»¤åºstateä¸ºæ°å¢çéä»¶
        fileInfos = fileInfos.filter((fileInfo: UploadFileInfo) => {
          if (fileInfo.hasOwnProperty('state')) {
            return fileInfo.state === FileState.New;
          }
          return true;
        });
        if (fileInfos.length === 0) {
          return of(true);
        }
        // æ¯å¦ä¸ä¼ å¤æ­
        const attachmentInfos = AttachmentUtil.convertToAttachmentInfos(fileInfos);
        const firstAttachmentInfo = AttachmentUtil.getFirstAttachmentInfo(attachmentInfos);
        return this.attachDataService.updateRowWithPropertyName(attachmentInfoFieldPath, firstAttachmentInfo);
      })
    );

    return result$;
  }
  /**
   * ä¸ä¼ å¤ä¸ªæä»¶
   */
  public uploadAndBatchAddRows(attachmentInfoFieldPath: string, rootDirId?: string, parentDirName?: string, fileType?: string): Observable<any> {
    const rootId = rootDirId ? rootDirId : this.defaultRootDirId;
    const formId = parentDirName ? parentDirName : this.defaultParentDirName;
    if (!rootId || !formId) {
      throw new Error('rootDirIdåparentDirNameä¸è½ä¸ºç©ºï¼è¯·å¡«å');
    }

    const uploadLimit: UploadLimit = new UploadLimit();
    if (fileType) {
      uploadLimit.fileType = fileType;
    }
    const dialog$ = from(this.uploadDialogService.uploadFileWithLimit(formId, rootId, uploadLimit));
    const result$ = dialog$.pipe(
      switchMap((fileInfos: UploadFileInfo[]) => {
        if (!fileInfos || fileInfos.length === 0) {
          this.notifyService.warning(this.languageService.plsUploadFirst, { hideTitle: true });
          return EMPTY;
        }
        // è¿æ»¤åºstateä¸ºæ°å¢çéä»¶
        fileInfos = fileInfos.filter((fileInfo: UploadFileInfo) => {
          if (fileInfo.hasOwnProperty('state')) {
            return fileInfo.state === FileState.New;
          }
          return true;
        });
        if (fileInfos.length === 0) {
          return of(true);
        }
        const attachmentInfos = AttachmentUtil.convertToAttachmentInfos(fileInfos);
        return this.attachDataService.updateRows(attachmentInfoFieldPath, attachmentInfos);
      })
    );
    return result$;
  }
  /**
   * ä¸ä¼ å¤ä¸ªæä»¶
   */
  public uploadAndBatchAddRowsWithPropertyName(attachmentInfoFieldPath: string, rootDirId?: string, parentDirName?: string, fileType?: string, id?: string): Observable<any> {
    const rootId = rootDirId ? rootDirId : this.defaultRootDirId;
    const formId = parentDirName ? parentDirName : this.defaultParentDirName;
    if (!rootId || !formId) {
      throw new Error('rootDirIdåparentDirNameä¸è½ä¸ºç©ºï¼è¯·å¡«å');
    }
    const uploadLimit: UploadLimit = new UploadLimit();
    if (fileType) {
      uploadLimit.fileType = fileType;
    }
    if (id) {
      // ä¿®æ­£å½åè¡
      const bindingList: BindingList = this.frameContext.bindingData.getList();
      if (bindingList.currentId !== id) {
        bindingList.setCurrentId(id, true, true);
      }
    }
    const dialog$ = from(this.uploadDialogService.uploadFileWithLimit(formId, rootId, uploadLimit));
    const result$ = dialog$.pipe(
      switchMap((fileInfos: UploadFileInfo[]) => {
        if (!fileInfos || fileInfos.length === 0) {
          this.notifyService.warning(this.languageService.plsUploadFirst, { hideTitle: true });
          return EMPTY;
        }
        // è¿æ»¤åºstateä¸ºæ°å¢çéä»¶
        fileInfos = fileInfos.filter((fileInfo: UploadFileInfo) => {
          if (fileInfo.hasOwnProperty('state')) {
            return fileInfo.state === FileState.New;
          }
          return true;
        });
        if (fileInfos.length === 0) {
          return of(true);
        }
        const attachmentInfos = AttachmentUtil.convertToAttachmentInfos(fileInfos);
        return this.attachDataService.updateRowsWithPropertyName(attachmentInfoFieldPath, attachmentInfos);
      })
    );
    return result$;
  }
  /**
   * ä¸è½½éä»¶ï¼æ ¹æ®éä»¶idï¼
   */
  public download(attachId: string, rootId?: string): any {
    if (!attachId) {
      this.notifyService.warning(this.languageService.plsSelectDownloadAtt, { hideTitle: true });
      return EMPTY;
    }
    rootId = rootId || 'default-root';
    const url = this.getDownloadUrl([attachId], rootId);
    // let url = '';
    // if (rootId) {
    //   url = `/api/runtime/dfs/v1.0/formdoc/filecontent?metadataid=${attachId}&rootid=${rootId}`;
    // } else {
    //   url = `/api/runtime/dfs/v1.0/formdoc/download/${attachId}`;
    // }
    window.open(url);
    return of(true);
  }
  /**
   * æ¹éä¸è½½éä»¶ï¼æ ¹æ®éä»¶idæ°ç»ï¼
   */
  public batchDownload(attachIds: string[], rootId: string): any {
    if (!attachIds || attachIds.length === 0) {
      this.notifyService.warning(this.languageService.plsSelectDownloadAtt, { hideTitle: true });
      return EMPTY;
    }
    // åªéæ©ä¸ä¸ªéä»¶æ¶æåä¸ªéä»¶ä¸è½½å¤ç
    if (attachIds.length === 1) {
      return this.download(attachIds[0], rootId);
    }
    // const attachIdsString = JSON.stringify(attachIds);
    // const url = `/api/runtime/dfs/v1.0/formdoc/multiple/download?metadataidlist=${attachIdsString}&rootid=${rootId}`;
    const url = this.getDownloadUrl(attachIds, rootId);
    window.open(url);
    return of(true);
  }
  /**
   * è·åä¸è½½è·¯å¾
   * @param metadataidlist éä»¶idæ°ç»
   * @param rootId rootId
   */
  private getDownloadUrl(metadataidlist: Array<string>, rootId: string): string {
    rootId = rootId || 'default-root';
    if (this.downloadService) {
      if (metadataidlist.length === 1) {
        return this.downloadService.getDownloadUrl(metadataidlist[0], rootId);
      } else {
        const attachIdsString = JSON.stringify(metadataidlist);
        return this.downloadService.getMultipleDownloadUrl(attachIdsString, rootId);
      }
    } else {
      console.warn('å å®å¨é®é¢ï¼éä»¶ä¸è½½æä¾å®å¨æ ¡éªæºå¶ï¼éä»¶ä¸è½½åè½ééæ°ç¼è¯ã');
      if (metadataidlist.length === 1) {
        return BasePathService.convertPath(`/api/runtime/dfs/v1.0/formdoc/filecontent?metadataid=${metadataidlist[0]}&rootid=${rootId}`);
      } else {
        const attachIdsString = JSON.stringify(metadataidlist);
        return BasePathService.convertPath(`/api/runtime/dfs/v1.0/formdoc/multiple/download?metadataidlist=${attachIdsString}&rootid=${rootId}`);
      }
    }
  }
  /**
   * ä¸è½½ï¼æ ¹æ®æ°æ®idï¼
   */
  public downloadByDataId(dataId: string, attachmentInfoFieldPath: string, rootId: string): Observable<any> {
    if (!dataId) {
      this.notifyService.warning(this.languageService.plsSelectDownloadAtt, { hideTitle: true });
      return EMPTY;
    }

    const dataIds = [dataId];
    const attachIds = this.getAttachmentIdsByPathAndDataIds(attachmentInfoFieldPath, dataIds);
    if (attachIds.length === 0) {
      this.notifyService.warning(this.languageService.noDownloadAtt, { hideTitle: true });
      return EMPTY;
    }

    const attachId = attachIds[0];
    return this.download(attachId);
  }

  /**
   * æ¹éä¸è½½éä»¶
   */
  public batchDownloadByDataIds(dataIds: string[] | string, attachmentInfoFieldPath: string, rootId: string): Observable<any> {
    if (typeof dataIds === 'string' && dataIds && dataIds.length > 0) {
      dataIds = dataIds.split(',').filter(p => p);
    }
    if (!dataIds || Array.isArray(dataIds) === false || dataIds.length === 0) {
      this.notifyService.warning(this.languageService.plsSelectDownloadAtt, { hideTitle: true });
      return EMPTY;
    }
    const ids = [].concat(dataIds);
    const attachIds = this.getAttachmentIdsByPathAndDataIds(attachmentInfoFieldPath, ids);
    if (attachIds.length === 0) {
      this.notifyService.warning(this.languageService.noDownloadAtt, { hideTitle: true });
      return EMPTY;
    }

    return this.batchDownload(attachIds, rootId);
  }

  /**
   * æ ¹æ®éä»¶UDTå­æ®µçè·¯å¾é¢è§éä»¶
   * @param attachmentInfoFieldPath éä»¶UDTå­æ®µpath
   * @param rootDirId è·ç®å½id
   * @param ids éä»¶id
   */
  public previewByAttachmentInfoFieldPath(attachmentInfoFieldPath: string, rootDirId: string, ids?: any) {
    if (!attachmentInfoFieldPath || !rootDirId) {
      throw new Error('attachmentInfoFieldPathårootDirIdä¸è½ä¸ºç©ºï¼è¯·å¡«å');
    }
    let attachIds = [];
    let dataIds = [];
    if (ids && ids.length > 0) {
      if (typeof (ids) === 'string') {
        dataIds.push(ids);
      } else {
        dataIds = ids;
      }
      attachIds = this.getAttachmentIdsByPathAndDataIds(attachmentInfoFieldPath, dataIds);
    } else {
      attachIds = this.getAttachmentIdsByPathAndDataIds(attachmentInfoFieldPath, null);
    }
    if (attachIds && attachIds.length === 0) {
      this.notifyService.warning(this.languageService.noAttachment, { hideTitle: true });
      return EMPTY;
    }
    return this.previewByAttachmentIds(attachIds, rootDirId);
  }
  /**
   * æ ¹æ®éä»¶UDTå­æ®µçè·¯å¾é¢è§å½åè¡çéä»¶
   * @param attachmentInfoFieldPath éä»¶UDTå­æ®µpath
   * @param rootDirId æ ¹ç®å½id
   */
  public previewByAttachmentInfoFieldPathWithIndex(attachmentInfoFieldPath: string, rootDirId: string): Observable<any> {
    if (!attachmentInfoFieldPath || !rootDirId) {
      throw new Error('attachmentInfoFieldPathårootDirIdä¸è½ä¸ºç©ºï¼è¯·å¡«å');
    }
    const currentRow = this.getCurrentRow(attachmentInfoFieldPath);
    const parentBindingPathArray = BindingPathConverter.toBindingPathArray(attachmentInfoFieldPath);
    const attachmentFieldName = parentBindingPathArray.pop();
    if (!currentRow[attachmentFieldName] || !currentRow[attachmentFieldName]['attachmentId']) {
      this.notifyService.warning(this.languageService.noAttachment, { hideTitle: true });
      return EMPTY;
    }
    const attachIds = this.getAttachmentIdsByPathAndDataIds(attachmentInfoFieldPath, null);
    if (attachIds && attachIds.length === 0) {
      this.notifyService.warning(this.languageService.noAttachment, { hideTitle: true });
      return EMPTY;
    }
    const attachmentId = this.getCurrentAttachmentId(attachmentInfoFieldPath);
    if (!attachmentId) {
      throw new Error('è¦é¢è§çéä»¶idä¸å­å¨ï¼è¯·ç¡®è®¤');
    } else {
      return this.previewFileListWithIndex(attachIds, rootDirId, attachmentId);
    }
  }
  /**
   * æ ¹æ®ç®å½é¢è§éä»¶
   * @param subDirName ç¶ç®å½åç§°
   * @param rootDirId æ ¹ç®å½id
   */
  public previewBySubDirName(subDirName: string, rootDirId: string): Observable<any> {
    if (!subDirName || !rootDirId) {
      throw new Error('subDirNameårootDirIdä¸è½ä¸ºç©ºï¼è¯·å¡«å');
    }
    const viewer$ = from(this.fileViewerService.viewerFormFile(subDirName, rootDirId));
    return viewer$;
  }
  /**
   * æ ¹æ®ç®å½é¢è§æå®ç´¢å¼çéä»¶
   * @param attachmentInfoFieldPath éä»¶UDTå­æ®µpath
   * @param subDirName å­ç®å½åç§°
   * @param rootDirId æ ¹ç®å½id
   */
  public previewBySubDirNameWithIndex(attachmentInfoFieldPath: string, subDirName: string, rootDirId: string): Observable<any> {
    if (!subDirName || !rootDirId) {
      throw new Error('subDirNameårootDirIdä¸è½ä¸ºç©ºï¼è¯·å¡«å');
    }
    // const attachIds = this.getAttachmentIdsByPathAndDataIds(attachmentInfoFieldPath, null);
    const attachmentId = this.getCurrentAttachmentId(attachmentInfoFieldPath);
    if (!attachmentId) {
      this.notifyService.warning(this.languageService.noAttachment, { hideTitle: true });
      return EMPTY;
    }
    const viewer$ = from(this.fileViewerService.viewerFormFileWithIndex(subDirName, rootDirId, attachmentId));
    return viewer$;
  }
  /**
   * æ ¹æ®éä»¶idæ°ç»é¢è§éä»¶
   * @param attachmentIds éä»¶idæ°ç»
   * @param rootDirId æ ¹ç®å½id
   */
  public previewByAttachmentIds(attachmentIds: string[], rootDirId: string): Observable<any> {
    const viewer$ = from(this.fileViewerService.viewerFileList(attachmentIds, rootDirId));
    return viewer$;
  }
  /**
   * æ ¹æ®éä»¶idæ°ç»é¢è§æå®ç´¢å¼çéä»¶
   * @param attachmentIds éä»¶idæ°ç»
   * @param rootDirId æ ¹ç®å½id
   * @param attachmentId éä»¶Id
   */
  public previewFileListWithIndex(attachmentIds: string[], rootDirId: string, attachmentId: string) {
    const viewer$ = from(this.fileViewerService.viewerFileListWithIndex(attachmentIds, rootDirId, attachmentId));
    return viewer$;
  }
  /**
   * çæçæ¬å·
   * @param versions åå²çæ¬å·
   * @description é»è®¤ç¼ç è§åv1.0 v2.0 ...
   */
  public genVersion(versions: string[]) {
    if (!versions) {
      versions = [];
    }
    const mainCode = versions.length + 1;
    return `V${mainCode}.0`;
  }
  /**
   * æ´æ°éä»¶çæ¬ä¿¡æ¯
   * @param versionField éä»¶çæ¬å­æ®µ
   * @param historyField æ¯å¦åå²çæ¬å­æ®µ
   * @param attachmentFieldPath éä»¶udtå­æ®µè·¯å¾
   */
  public updateAttachmentVersion(versionField: string, historyField: string, attachmentFieldPath: string) {
    /**
     * éåææéä»¶è¡
     * æ¾å°æææ²¡æéä»¶çæ¬çè¡
     * éåè¿äºè¡
     * éè¿æä»¶åå»æ¥æ¾ååçä¸æéä»¶çæ¬å·çè¡
     * è¿äºè¡åå²çæ¬å­æ®µç½®ä¸ºtrue
     * æ çæ¬å·çè¡ï¼çæ¬= ä¸è¡æ° + 1
     *
     */
    const bindingPaths = attachmentFieldPath.split('/').filter(p => p);
    // å¼¹åºéä»¶udtå­æ®µ
    const attachmentField = bindingPaths.pop();
    // è·åå°ææçéä»¶
    const attachmentBindingList = this.frameContext.bindingData.getValue(bindingPaths) as BindingList;
    const befRepository = this.frameContext.repository as BefRepository<any>;
    const entityManager = befRepository.entityManager;
    const dataPath = DataPathCreator.createByShortPathFromRoot(bindingPaths, entityManager, this.frameContext.bindingData);
    const paths = dataPath.toArray().map((path: string) => {
      if (path.startsWith('PropName:')) {
        return path.split(':')[1];
      } else {
        return path;
      }
    });
    if (attachmentBindingList) {
      const attachments = attachmentBindingList.toJSON();
      // åªå¤çæéä»¶çæåµ
      if (attachments) {
        const versionLessRows = attachments.filter(item => !item[versionField]);
        versionLessRows.forEach(item => {
          const fileName = item[attachmentField]['fileName'];
          const versionedRows = attachments.filter(row => row[attachmentField]['fileName'] === fileName && row[versionField]);
          paths.pop();
          paths.push(`DataId:${item[attachmentBindingList.primaryKey]}`);
          let entity = this.frameContext.repository.entityCollection.getEntityByPath(paths);
          const version = this.genVersion(versionedRows);
          entity[versionField] = version;
          entity[historyField] = false;
          // å¤çåå²è®°å½
          versionedRows.forEach(row => {
            paths.pop();
            paths.push(`DataId:${row[attachmentBindingList.primaryKey]}`);
            entity = this.frameContext.repository.entityCollection.getEntityByPath(paths);
            entity[historyField] = true;
          });
        });
      }
    }
  }
  public isAttachmentCanDelete(historyField: string, attachmentFieldPath: string) {
    const bindingPaths = attachmentFieldPath.split('/').filter(p => p);
    // å¼¹åºéä»¶udtå­æ®µ
    bindingPaths.pop();
    const attachmentBindingList = this.frameContext.bindingData.getValue(bindingPaths) as BindingList;
    const bindingObject = attachmentBindingList.currentItem;
    if (bindingObject[historyField] === true) {
      this.notifyService.warning(this.languageService.historyAttachment, { hideTitle: true });
      return EMPTY;
    }
  }
  public updateAttachmentHistory(versionField: string, historyField: string, attachmentFieldPath: string) {
    const bindingPaths = attachmentFieldPath.split('/').filter(p => p);
    // å¼¹åºéä»¶udtå­æ®µ
    const attachmentField = bindingPaths.pop();
    // è·åå°ææçéä»¶
    const attachmentBindingList = this.frameContext.bindingData.getValue(bindingPaths) as BindingList;
    // const befRepository = this.frameContext.repository as BefRepository<any>;
    // const entityManager = befRepository.entityManager;
    if (attachmentBindingList) {
      const attachments = attachmentBindingList.toJSON();
      const versionedRows = attachments.filter(item => item[versionField]);
      const fileNameMap = new Map<string, Array<any>>();
      const befRepository = this.frameContext.repository as BefRepository<any>;
      const entityManager = befRepository.entityManager;
      const dataPath = DataPathCreator.createByShortPathFromRoot(bindingPaths, entityManager, this.frameContext.bindingData);
      const paths = dataPath.toArray().map((path: string) => {
        if (path.startsWith('PropName:')) {
          return path.split(':')[1];
        } else {
          return path;
        }
      });
      versionedRows.forEach(item => {
        const fileName = item[attachmentField]['fileName'];
        if (fileNameMap.has(fileName)) {
          fileNameMap.get(fileName).push(item);
        } else {
          fileNameMap.set(fileName, [item]);
        }
      });
      Array.from(fileNameMap.values()).forEach((array: Array<any>) => {
        array.sort((x, y) => {
          const xVersion = parseInt(x[versionField].replace(/[a-zA-Z\.]/g, ''));
          const yVersion = parseInt(y[versionField].replace(/[a-zA-Z\.]/g, ''));
          return yVersion - xVersion;
        });
        const row = array[0];
        paths.pop();
        paths.push(`DataId:${row[attachmentBindingList.primaryKey]}`);
        const entity = this.frameContext.repository.entityCollection.getEntityByPath(paths);
        entity[historyField] = false;
      });
    }
  }
  /**
   * å é¤éä»¶
   * @param attachmentInfoFieldPath éä»¶udtå­æ®µè·¯å¾
   * @param id æ°æ®id
   * @param rootDirId æ ¹ç®å½
   * @returns
   */
  public removeAttachment(attachmentInfoFieldPath: string, id: string, rootDirId: string): Observable<any> {
    const rootId = rootDirId;
    if (!rootId) {
      throw new Error('rootDirIdåparentDirNameä¸è½ä¸ºç©ºï¼è¯·å¡«å');
    }
    const dataIds = [id];
    const attachIds = this.getAttachmentIdsByPathAndDataIds(attachmentInfoFieldPath, dataIds);
    if (attachIds.length === 0) {
      this.notifyService.warning(this.languageService.plsSelectRemoveAtt, { hideTitle: true });
      return EMPTY;
    }
    const attachmentId = attachIds[0];
    return this.attachDataService.removeAttachment(attachmentInfoFieldPath, { attachmentId, fileName: null });
  }
  /**
   * è·åå½åè§å¾æ¨¡åå½åè¡çéä»¶id
   * @param attachmentInfoFieldPath éä»¶udtå­æ®µ
   */
  private getCurrentAttachmentId(attachmentInfoFieldPath: string) {
    const parentBindingPathArray = BindingPathConverter.toBindingPathArray(attachmentInfoFieldPath);
    const attachmentFieldName = parentBindingPathArray.pop();
    const bindingList: BindingList = this.frameContext.bindingData.getValue(parentBindingPathArray) as BindingList;
    const currentItem = bindingList.currentItem;
    if (currentItem && currentItem.primaryKeyValue) {
      return currentItem[attachmentFieldName] && currentItem[attachmentFieldName]['attachmentId'] || null;
    } else {
      return null;
    }
  }
  /**
   * è·åå½åè¡
   * @param attachmentInfoFieldPath udtå­æ®µ
   */
  private getCurrentRow(attachmentInfoFieldPath: string) {
    const parentBindingPathArray = BindingPathConverter.toBindingPathArray(attachmentInfoFieldPath);
    parentBindingPathArray.pop();
    const bindingList: BindingList = this.frameContext.bindingData.getValue(parentBindingPathArray) as BindingList;
    const currentItem = bindingList && bindingList.currentItem;
    return currentItem;
  }
  /**
   * è·åæå®éä»¶ä¿¡æ¯è¡¨çæå®è¡
   * @param attachmentInfoFieldPath
   * @param primaryValue
   * @returns
   */
  private getSpecialRow(attachmentInfoFieldPath: string, primaryValue: string) {
    const parentBindingPathArray = BindingPathConverter.toBindingPathArray(attachmentInfoFieldPath);
    parentBindingPathArray.pop();
    const bindingList: BindingList = this.frameContext.bindingData.getValue(parentBindingPathArray) as BindingList;
    const currentItem = bindingList && bindingList.findById(primaryValue);
    return currentItem;
  }
  /**
   * è·ådataIdså¯¹åºEntityä¸çéä»¶idæ°ç»
   */
  private getAttachmentIdsByPathAndDataIds(attachmentInfoFieldPath: string, dataIds?: string[]): string[] {

    // è§£æè·¯å¾
    const parentBindingPathArray = BindingPathConverter.toBindingPathArray(attachmentInfoFieldPath);
    const attachmentFieldName = parentBindingPathArray.pop();

    // è·åéä»¶æå¨å®ä½çæ°æ®åè¡¨ï¼ä¸ä¼ édataIdsåæ°ï¼åè¿åå¨é¨
    const entityListData = this.entityService.getEntityListData(parentBindingPathArray);
    let filteredEntityListData = [];
    if (dataIds && Array.isArray(dataIds) === true) {
      filteredEntityListData = entityListData.filter((entityData: any) => {
        return dataIds.indexOf(entityData.id) > -1;
      });
    } else {
      filteredEntityListData = entityListData;
    }

    // è½¬æ¢ä¸ºéä»¶Idæ°ç»
    const attachmentIds = [];
    filteredEntityListData.forEach((entityData: any) => {
      if (entityData[attachmentFieldName]) {
        const attachmentId = entityData[attachmentFieldName]['attachmentId'];
        if (attachmentId) {
          attachmentIds.push(attachmentId);
        }
      }
    });

    return attachmentIds;
  }
}

export { AttachmentService };
